export type NoteKind = "note" | "ack";
export type NoteAuthor = { type: "user" | "agent"; id: string; name: string; organizationId: string; organizationName: string; sameWorkspace: boolean };
export type NoteModel = { id: string; loopId: string; kind: NoteKind; runId: string | null; body: string; createdAt: string; author: NoteAuthor };
export type NoteInput = { kind?: NoteKind; body?: string; runId?: string };

/** The newest acknowledgement that points at this run, or null. Plain notes mentioning the run do not count. */
export function acknowledgementFor(notes: NoteModel[], runId: string): NoteModel | null {
  let latest: NoteModel | null = null;
  for (const note of notes) {
    if (note.kind !== "ack" || note.runId !== runId) continue;
    if (!latest || note.createdAt > latest.createdAt) latest = note;
  }
  return latest;
}

/** First and last initial for the avatar; one letter for a single word; a placeholder when the name is blank. */
export function initialsFor(name: string): string {
  const words = name.trim().split(/\s+/u).filter(Boolean);
  if (!words.length) return "?";
  const first = words[0].charAt(0);
  const last = words.length > 1 ? words[words.length - 1].charAt(0) : "";
  return `${first}${last}`.toUpperCase();
}

export function kindLabel(kind: NoteKind): string {
  return kind === "ack" ? "acknowledged run" : "note";
}
